import ProxyPathNamesWarning from "../../../../contents/docs/advanced/_snippets/proxy-path-names-warning.mdx";
import * as React from 'react';
export default {
  ProxyPathNamesWarning,
  React
};